import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { v4 as uuidv4 } from 'uuid'

import { selectAppName } from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

import { AppName, USER_ID_KEY } from 'root-constants'

export const useUserId = (): void => {
  const appName = useSelector(selectAppName)
  const uuid = useSelector(selectUUID)

  useEffect(() => {
    if (sessionStorage.getItem(USER_ID_KEY)) return

    if (appName === AppName.STYLIO && uuid) {
      sessionStorage.setItem(USER_ID_KEY, uuid)

      return
    }

    const giaAnalyticsUserId = uuidv4()

    sessionStorage.setItem(USER_ID_KEY, giaAnalyticsUserId)
  }, [appName])
}
